class FacetDrawer extends HTMLElement {
	constructor() {
		super();
		this.mainDetailsToggle = this.querySelector("details");
		this.summaryElement = this.querySelector("summary");
		this.addEventListener("keyup", (event) => {
			if (event.code.toUpperCase() === "ESCAPE") this.close();
		});
		if (this.summaryElement) {
			this.summaryElement.addEventListener('click', this.onSummaryClick.bind(this));
		}
		this.bindEvents();
		this.addEventListener('click', this.onOverlayClick.bind(this));
	}

	bindEvents() {
		this.querySelectorAll('button').forEach(button => {
			button.addEventListener('click', (event) => {
				if (button.classList.contains('mobile-facets__close-button-top')) {
					this.close();
				}
			});
		});
	}

	onSummaryClick(event) {
		if (!this.mainDetailsToggle) return;
		// Small delay to let browser toggle 'open'
		setTimeout(() => {
			const isOpen = this.mainDetailsToggle.hasAttribute("open");
			if (isOpen) {
				if (this.summaryElement) this.summaryElement.setAttribute('aria-expanded', true);
				document.body.classList.add('overflow-hidden');
			} else {
				this.close();
			}
		}, 10);
	}

	onOverlayClick(event) {
		// Close only if clicking exactly on the mobile-facets container (the backdrop)
		// and NOT on the mobile-facets__inner content.
		if (event.target.classList.contains('mobile-facets')) {
			this.close();
		}
	}

	close() {
		if (this.mainDetailsToggle) this.mainDetailsToggle.removeAttribute("open");
		if (this.summaryElement) this.summaryElement.setAttribute('aria-expanded', false);
		document.body.classList.remove('overflow-hidden');
	}
}
customElements.define("facet-drawer", FacetDrawer);

class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

		this.debouncedOnSubmit = debounce((event) => {
			this.onSubmitHandler(event);
		}, 500);

		this.querySelectorAll("form").forEach(form => {
			form.addEventListener("input", this.debouncedOnSubmit.bind(this));
		});

		const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
		if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

		this.initCustomEvents();
	}

	initCustomEvents() {
		// Grid View Switcher
		const gridBtns = this.querySelectorAll('.grid-view-btn');
		const productGrid = document.getElementById('product-grid');

		gridBtns.forEach(btn => {
			btn.addEventListener('click', () => {
				const cols = btn.dataset.columns;
				gridBtns.forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				if (productGrid) {
					productGrid.classList.remove('grid-2', 'grid-4');
					productGrid.classList.add(`grid-${cols}`);
					// Store preference
					localStorage.setItem('haut-grid-view', cols);
				}
			});
		});

		// Restore Grid Preference
		const savedGrid = localStorage.getItem('haut-grid-view');
		if (savedGrid && productGrid) {
			const activeBtn = this.querySelector(`.grid-view-btn[data-columns="${savedGrid}"]`);
			if (activeBtn) activeBtn.click();
		}

		// Add ALL chip active fallback
		const filterChips = this.querySelectorAll('.filter-chip, .filter-chip-size');
		let hasActive = false;
		filterChips.forEach(chip => {
			if(chip.classList.contains('active') && chip.dataset.clearAll !== 'true') {
				hasActive = true;
			}
		});
		if(!hasActive) {
			const allChip = this.querySelector('.filter-chip[data-clear-all="true"]');
			if(allChip) allChip.classList.add('active');
		}

		// Event Delegation for Filter Chips
		this.addEventListener('click', (event) => {
			const chip = event.target.closest('.filter-chip, .filter-chip-size');
			if (!chip) return;

			const url = chip.dataset.url;
			if (url !== undefined) {
				// If this is the ALL/clear-all chip, strictly navigate to the base collection URL to reset everything
				if (chip.dataset.clearAll === 'true') {
					location.href = url;
					return;
				}
				// If URL contains '?', it's a faceted filter (Search & Discovery)
				if (url.includes('?')) {
					const searchParams = url.slice(url.indexOf('?') + 1);
					FacetFiltersForm.renderPage(searchParams);
				} else {
					// It's a manual tag URL fallback (e.g., /collections/all/blazer)
					location.href = url;
				}
				return;
			}

			// Fallback to searching for matching checkbox if no data-url
			const label = chip.textContent.trim().toLowerCase();
			const mapping = {
				'male': ['men', 'male', 'man'],
				'female': ['women', 'female', 'woman']
			};
			const searchTerms = mapping[label] || [label];

			const inputs = document.querySelectorAll('.mobile-facets__checkbox, .mobile-facets__radio');
			let targetInput = Array.from(inputs).find(input => {
				const parent = input.closest('.mobile-facets__item');
				const labelEl = parent ? parent.querySelector('.mobile-facets__label, .mobile-facets__label-radio') : null;
				if (!labelEl) return false;
				const text = labelEl.childNodes[0].textContent.trim().toLowerCase();
				return searchTerms.some(term => text === term || text.includes(term));
			});

			if (targetInput) {
				targetInput.click();
			}
		});
	}

	static setListeners() {
		const onHistoryChange = (event) => {
			const searchParams = event.state
				? event.state.searchParams
				: FacetFiltersForm.searchParamsInitial;
			if (searchParams === FacetFiltersForm.searchParamsPrev) return;
			FacetFiltersForm.renderPage(searchParams, null, false);
		};
		window.addEventListener("popstate", onHistoryChange);
	}

	static toggleActiveFacets(disable = true) {
		document.querySelectorAll(".js-facet-remove").forEach((element) => {
			element.classList.toggle("disabled", disable);
		});
	}

	static renderPage(searchParams, event, updateURLHash = true) {
		FacetFiltersForm.searchParamsPrev = searchParams;
		const sections = FacetFiltersForm.getSections();
		const countContainer = document.getElementById("ProductCount");
		const countContainerDesktop = document.getElementById(
			"ProductCountDesktop"
		);
		const gridContainer = document.getElementById("ProductGridContainer");
		if (gridContainer) {
			const collection = gridContainer.querySelector(".collection");
			if (collection) collection.classList.add("loading");
		}

		if (countContainer) {
			countContainer.classList.add("loading");
		}
		if (countContainerDesktop) {
			countContainerDesktop.classList.add("loading");
		}

		sections.forEach((section) => {
			const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
			const filterDataUrl = (element) => element.url === url;

			FacetFiltersForm.filterData.some(filterDataUrl)
				? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
				: FacetFiltersForm.renderSectionFromFetch(url, event);
		});

		if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
	}

	static renderSectionFromFetch(url, event) {
		fetch(url)
			.then((response) => response.text())
			.then((responseText) => {
				const html = responseText;
				FacetFiltersForm.filterData = [
					...FacetFiltersForm.filterData,
					{ html, url },
				];
				FacetFiltersForm.renderFilters(html, event);
				FacetFiltersForm.renderProductGridContainer(html);
				FacetFiltersForm.renderProductCount(html);
			});
	}

	static renderSectionFromCache(filterDataUrl, event) {
		const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
		FacetFiltersForm.renderFilters(html, event);
		FacetFiltersForm.renderProductGridContainer(html);
		FacetFiltersForm.renderProductCount(html);
	}

	static renderProductGridContainer(html) {
		document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
			.parseFromString(html, "text/html")
			.getElementById("ProductGridContainer").innerHTML;
		if (
			document.querySelector(".js-load-more") ||
			document.querySelector(".js-infinite-scroll")
		)
			loadMore();
		try {
			colorSwatches();
		} catch (err) { }
	}

	static renderProductCount(html) {
		const count = new DOMParser()
			.parseFromString(html, "text/html")
			.getElementById("ProductCount").innerHTML;
		const container = document.getElementById("ProductCount");
		const containerDesktop = document.getElementById("ProductCountDesktop");

		if (container) {
			container.innerHTML = count;
			container.classList.remove("loading");
		}

		if (containerDesktop) {
			containerDesktop.innerHTML = count;
			containerDesktop.classList.remove("loading");
		}

		const gridContainer = document.getElementById("ProductGridContainer");
		if (gridContainer) {
			const collection = gridContainer.querySelector(".collection");
			if (collection) collection.classList.remove("loading");
		}
	}

	static renderFilters(html, event) {
		const parsedHTML = new DOMParser().parseFromString(html, "text/html");

		const facetDetailsElements = parsedHTML.querySelectorAll(
			"#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
		);
		const matchesIndex = (element) => {
			const jsFilter = event ? event.target.closest(".js-filter") : undefined;
			return jsFilter
				? element.dataset.index === jsFilter.dataset.index
				: false;
		};
		const facetsToRender = Array.from(facetDetailsElements).filter(
			(element) => !matchesIndex(element)
		);
		const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

		facetsToRender.forEach((element) => {
			document.querySelectorAll(
				`.js-filter[data-index="${element.dataset.index}"]`
			).forEach(filter => {
				filter.innerHTML = element.innerHTML;
			});
		});

		FacetFiltersForm.renderActiveFacets(parsedHTML);
		FacetFiltersForm.renderAdditionalElements(parsedHTML);

		if (countsToRender)
			FacetFiltersForm.renderCounts(
				countsToRender,
				event.target.closest(".js-filter")
			);

		// Re-init custom elements and events
		const form = document.querySelector('facet-filters-form');
		if (form) form.initCustomEvents();

		document.querySelectorAll('price-range').forEach(pr => {
			if (typeof pr.init === 'function') pr.init();
		});

		// Restore focus to the element that was being interacted with
		if (event && event.target && event.target.id) {
			const activeElement = document.getElementById(event.target.id);
			if (activeElement) activeElement.focus();
		} else if (event && event.target && (event.target.classList.contains('mobile-facets__checkbox') || event.target.classList.contains('mobile-facets__radio'))) {
			// Find by name and value if ID isn't unique or available
			const name = event.target.name;
			const value = event.target.value;
			const newElement = document.querySelector(`[name="${name}"][value="${value}"]`);
			if (newElement) newElement.focus();
		}
	}

	static renderActiveFacets(html) {
		const activeFacetElementSelectors = [
			".active-facets-mobile",
			".active-facets-desktop",
		];

		activeFacetElementSelectors.forEach((selector) => {
			const activeFacetsElement = html.querySelector(selector);
			if (!activeFacetsElement) return;
			document.querySelector(selector).innerHTML =
				activeFacetsElement.innerHTML;
		});

		FacetFiltersForm.toggleActiveFacets(false);
	}

	static renderAdditionalElements(html) {
		const mobileElementSelectors = [
			".mobile-facets__open",
			".mobile-facets__count",
			".sorting",
			".facets-custom-bar",
			".facet-custom-count"
		];

		mobileElementSelectors.forEach((selector) => {
			const source = html.querySelector(selector);
			const target = document.querySelector(selector);
			if (source && target) {
				target.innerHTML = source.innerHTML;
			}
		});

		const mobileForm = document.getElementById("FacetFiltersFormMobile");
		if (mobileForm) {
			const drawer = mobileForm.closest("facet-drawer") || mobileForm.closest("menu-drawer");
			if (drawer && typeof drawer.bindEvents === 'function') drawer.bindEvents();
		}
	}

	static renderCounts(source, target) {
		const targetElement = target.querySelector(".facets__selected");
		const sourceElement = source.querySelector(".facets__selected");

		const targetElementAccessibility = target.querySelector(".facets__summary");
		const sourceElementAccessibility = source.querySelector(".facets__summary");

		if (sourceElement && targetElement) {
			target.querySelector(".facets__selected").outerHTML =
				source.querySelector(".facets__selected").outerHTML;
		}

		if (targetElementAccessibility && sourceElementAccessibility) {
			target.querySelector(".facets__summary").outerHTML =
				source.querySelector(".facets__summary").outerHTML;
		}
	}

	static updateURLHash(searchParams) {
		history.pushState(
			{ searchParams },
			"",
			`${window.location.pathname}${searchParams && "?".concat(searchParams)}`
		);
	}

	static getSections() {
		const grid = document.getElementById("product-grid");
		return [
			{
				section: grid ? grid.dataset.id : (document.querySelector('.collection-grid-section')?.id || ''),
			},
		];
	}

	createSearchParams(form) {
		const formData = new FormData(form);
		return new URLSearchParams(formData).toString();
	}

	onSubmitForm(searchParams, event) {
		FacetFiltersForm.renderPage(searchParams, event);
	}

	onSubmitHandler(event) {
		event.preventDefault();
		const form = event.target.closest("form");
		if (!form) return;

		const searchParams = this.createSearchParams(form);
		this.onSubmitForm(searchParams, event);
	}

	onActiveFilterClick(event) {
		event.preventDefault();
		FacetFiltersForm.toggleActiveFacets();
		const url =
			event.currentTarget.href.indexOf("?") == -1
				? ""
				: event.currentTarget.href.slice(
					event.currentTarget.href.indexOf("?") + 1
				);
		FacetFiltersForm.renderPage(url);
	}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
	constructor() {
		super();
		this.init();
	}

	init() {
		this.querySelectorAll("input").forEach((element) =>
			element.addEventListener("change", this.onRangeChange.bind(this))
		);
		this.setMinAndMaxValues();
		this.controlSlider();
		this.controlInput();
		this.fillSlider();
	}

	onRangeChange(event) {
		this.adjustToValidValues(event.currentTarget);
		this.setMinAndMaxValues();
	}

	setMinAndMaxValues() {
		const inputs = this.querySelectorAll(".field__input");
		const minInput = inputs[0];
		const maxInput = inputs[1];
		if (minInput && maxInput) {
			if (maxInput.value) minInput.setAttribute("max", maxInput.value);
			if (minInput.value) maxInput.setAttribute("min", minInput.value);
			if (minInput.value === "") maxInput.setAttribute("min", 0);
			if (maxInput.value === "")
				minInput.setAttribute("max", maxInput.getAttribute("max"));
		}
	}

	adjustToValidValues(input) {
		const value = Number(input.value);
		const min = Number(input.getAttribute("min"));
		const max = Number(input.getAttribute("max"));

		if (value < min) input.value = min;
		if (value > max) input.value = max;
	}

	fillSlider() {
		const inputWrapper = this.querySelector(".facets__range");
		if (!inputWrapper) return;
		const inputsRange = inputWrapper.querySelectorAll(".field__range");
		const inputRangeFrom = inputsRange[0];
		const inputRangeTo = inputsRange[1];

		const range = inputRangeTo.max - inputRangeTo.min;
		const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
		const toCurrent = inputRangeTo.value - inputRangeTo.min;
		const minRange = (fromCurrent / range) * 100;
		const maxRange = (toCurrent / range) * 100;

		inputWrapper.setAttribute(
			"style",
			`--range-min: ${minRange}%; --range-max: ${maxRange}%`
		);
	}

	controlSlider() {
		const inputWrapper = this.querySelector(".facets__range");
		const inputNumberWrapper = this.querySelector(".facets__price-wrapper");
		if (!inputWrapper || !inputNumberWrapper) return;

		const inputsRange = inputWrapper.querySelectorAll(".field__range");
		const inputRangeFrom = inputsRange[0];
		const inputRangeTo = inputsRange[1];
		const inputsNumber = inputNumberWrapper.querySelectorAll(".field__input");
		const inputNumberFrom = inputsNumber[0];
		const inputNumberTo = inputsNumber[1];

		inputRangeFrom.oninput = () => {
			const from = parseInt(inputRangeFrom.value, 10);
			const to = parseInt(inputRangeTo.value, 10);
			if (from > to) {
				inputRangeFrom.value = to;
				inputNumberFrom.value = to;
			} else {
				inputNumberFrom.value = from;
			}
			this.fillSlider();
		};

		inputRangeTo.oninput = () => {
			const from = parseInt(inputRangeFrom.value, 10);
			const to = parseInt(inputRangeTo.value, 10);
			if (from <= to) {
				inputRangeTo.value = to;
				inputNumberTo.value = to;
			} else {
				inputNumberTo.value = from;
				inputRangeTo.value = from;
			}
			this.fillSlider();
		};
	}

	controlInput() {
		const inputWrapper = this.querySelector(".facets__range");
		const inputNumberWrapper = this.querySelector(".facets__price-wrapper");
		if (!inputWrapper || !inputNumberWrapper) return;

		const inputsNumber = inputNumberWrapper.querySelectorAll(".field__input");
		const inputNumberFrom = inputsNumber[0];
		const inputNumberTo = inputsNumber[1];
		const inputsRange = inputWrapper.querySelectorAll(".field__range");
		const inputRangeFrom = inputsRange[0];
		const inputRangeTo = inputsRange[1];

		inputNumberFrom.oninput = () => {
			const from = parseInt(inputNumberFrom.value, 10);
			const to = parseInt(inputNumberTo.value, 10);
			if (from > to) {
				inputRangeFrom.value = to;
				inputNumberFrom.value = to;
			} else {
				inputRangeFrom.value = from;
			}
			this.fillSlider();
		};

		inputNumberTo.oninput = () => {
			const from = parseInt(inputNumberFrom.value, 10);
			const to = parseInt(inputNumberTo.value, 10);
			if (from <= to) {
				inputRangeTo.value = to;
				inputNumberTo.value = to;
			} else {
				inputNumberTo.value = from;
			}
			this.fillSlider();
		};
	}
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
	constructor() {
		super();
		const facetLink = this.querySelector("a");
		facetLink.setAttribute("role", "button");
		facetLink.addEventListener("click", this.closeFilter.bind(this));
		facetLink.addEventListener("keyup", (event) => {
			event.preventDefault();
			if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
		});
	}

	closeFilter(event) {
		event.preventDefault();
		const form =
			this.closest("facet-filters-form") ||
			document.querySelector("facet-filters-form");
		form.onActiveFilterClick(event);
	}
}


customElements.define("facet-remove", FacetRemove);
